<div class="batch-notification" [ngClass]="{ 'batch-notification-error': isError }">
  <div class="batch-notification-text">
    <div class="batch-notification-text-header-wrapper">
      <div>
        <div class="batch-notification-text-hint" *ngIf="!!topHint">{{ topHint | translate }}</div>
        <div class="batch-notification-text-header">{{ header | translate }}</div>
      </div>

      <div class="batch-notification-text-close" *ngIf="isShowClose" (click)="close.emit()">
        <img class="mr-1" src="assets/icons/icon_close_gray_sm.svg" />
        <span>{{ "BUTTON.CLOSE" | translate }}</span>
      </div>
    </div>
    <div class="batch-notification-text-hint" *ngIf="!!hint">{{ hint | translate }}</div>
    <div class="batch-notification-text-contact-support" *ngIf="isShowContactSupport">
      {{ "NEED_HELP" | translate }}
      <a href="" class="ml-1" [routerLink]="['/', 'contact-support']">{{ "CONTACT_SUPPORT_CAMEL" | translate }}</a>
    </div>
    <div class="batch-notification-text-reload" (click)="reload.emit()">
      <img src="assets/icons/icon_add_blue.svg" class="mr-2" />
      <span>{{ "RELOAD_YOUR_ERP_REPORT" | translate }}</span>
    </div>
  </div>
  <div class="batch-notification-link">
    <div class="batch-notification-link-download" (click)="download()">
      <img alt="download" src="/assets/icons/icon_download_sm_blue.svg" class="ml-2" />
      <span>{{ "BUTTON.DOWNLOAD" | translate }}</span>
    </div>
  </div>
</div>

<a #link class="d-none" download></a>
